module.exports = __webpack_public_path__ + "img/Orientacion II.8998f8e5.png";